import { BubbleHaloMetadata } from '@/components/public/Visualisations/BubblesV2/Metadata'
import { Shapes } from '@/components/public/Visualisations/types'
import Konva from 'konva'

export class BubbleHaloCircleV2 extends Konva.Circle implements Shapes.Shape {
  static readonly shapeName = 'bubble-halo'
  private _metadata: BubbleHaloMetadata
  capabilities: Shapes.Capability[] = []

  constructor(metadata: BubbleHaloMetadata) {
    super({
      listening: false,
    })

    this._metadata = metadata
  }

  get key() {
    return this.path.toString()
  }

  get path() {
    return this._metadata.path
  }

  get center() {
    return this.position()
  }

  refresh() {
    if (this._metadata.show) {
      this.visible(true)
      this.radius(this._metadata.radius)
      this.strokeWidth(this._metadata.strokeWidth)
      this.stroke(this._metadata.strokeColour)
    } else {
      this.visible(false)
    }
  }
}
